module.exports = __webpack_public_path__ + "img/preauth2.e637d50e.svg";